import confetti from 'canvas-confetti';

// Demo: https://www.kirilv.com/canvas-confetti/
export function useConfetti(options: confetti.Options) {
    const myCanvas = document.createElement('canvas');
    myCanvas.style.position = 'fixed';
    myCanvas.style.bottom = '0px';
    myCanvas.style.right = '0px';
    document.body.appendChild(myCanvas);
    confetti.create(myCanvas, {
        resize: true,
        useWorker: true
    });
    confetti(options);
    myCanvas.remove();
}
